export const getTaxRatePercent = (taxRate: number | string | null | undefined): string => {
  if (Number.isNaN(taxRate)) return "0";
  return (Number(taxRate) * 100).toFixed(2);
};
